import React from "react";
import PropTypes from "prop-types";

const Button = ({ className, type, onClick, disabled, children }) => {
  return (
    <button className={className} onClick={onClick} type={type} disabled={disabled}>
      {children}
    </button>
  );
};

export default Button;
